import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { useMediaQuery, Grid, Button, Typography } from '@material-ui/core';
import { Image } from 'components/atoms';
import { SectionHeader } from 'components/molecules';
import {Box} from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  image: {
    boxShadow:
      '25px 60px 125px -25px rgba(80,102,144,.1), 16px 40px 75px -40px rgba(0,0,0,.2)',
    borderRadius: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      maxWidth: 500,
    },
  },
}));

const  Buccal= props => {
  const { className, ...rest } = props;
  const classes = useStyles();

  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <Box  className={className} {...rest} marginBottom={2} marginLeft= {2} marginRight={2} marginTop= {2} display="flex" justifyContent="space-evenly" alignItems="center" padding={2} border="1px solid #ccc" borderRadius="4px">
      <Grid
        container
        justify="space-between"
        spacing={4}
        direction={isMd ? 'row' : 'column-reverse'}
      >
        <Grid
          item
          container
          alignItems="center"
          xs={12}
          md={6}
          data-aos={'fade-up'}
        >
          <SectionHeader
            title={
              <span>
      Hero Head
                <br />
                <Typography component="span" variant="inherit" color="primary">
            Isohelix DNA Buccal Swab
                </Typography>
              </span>
            }
            subtitle= " The Isohelix range of DNA Buccal Swabs has been specifically designed to give increased yields of high-quality buccal cell and genomic DNA. Buccal cell sampling offers a viable alternative to blood collection and together with the Isohelix range of DNA Isolation and Stabilization kits, enables high yields of pure, intact DNA to be collected easily and quickly.Our DNA swabs are suitable for both human and veterinary use and offer significant advantages over other DNA swab designs in terms of efficiency of cell collection by the unique swab matrix, which combined with a quick release surface, maximizes yields of DNA. Swab batches are ethylene oxide treated and routinely tested for human DNA contamination."
            ctaGroup={[
              <Button variant="contained" color="primary" size="large">
                Quickbook
              </Button>,
              <Button variant="outlined" color="primary" size="large">
             Talk to us
              </Button>,
            ]}
            align="left"
            disableGutter
            titleVariant="h3"
          />
        </Grid>
        <Grid
          item
          container
          justify="flex-start"
          alignItems="center"
          xs={12}
          md={6}
          data-aos={'fade-up'}
        >
          <Image
            src="https://ik.imagekit.io/j6phbjneuop/isohleix/Isohelix2_hHgBJNkiZ.png?updatedAt=1627468699391"
            alt="Isohelix"
            className={classes.image}
            data-aos="flip-left"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="2000"
          />
        </Grid>
      </Grid>
    </Box>
  );
};

Buccal.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
};

export default Buccal;
